import React, { useEffect, useState } from 'react'
import { Image } from 'antd-mobile'
import { apis, utils } from '@/utils'
import styles from './Nav1.module.less'
import { ModuleItemProps } from '@/types/interfaces'
import { useNavigate } from 'react-router-dom'
import iconNav from '@/assets/img/icon/nav-icon.png'
import { routesMap } from '@/router/routes'
import categoryImg from './category.svg'
import { t } from '@/utils/i18n'

const { to, capitalizeFirstLetter, concatenateImageUrl } = utils
const { corpApi } = apis

interface ModuleProps {
  module: ModuleItemProps
}

interface ModuleDetails {
  [key: string]: any
}

const Nav1: React.FC<ModuleProps> = (props) => {
  const { corpId, corpModuleId } = props.module
  const navigate = useNavigate()
  const [detail, setDetail] = useState<ModuleDetails[]>([])

  /*
   * 获取模块详情
   */
  async function getModuleDetail() {
    if (!corpId || !corpModuleId) return

    // 获取详情
    const [err, res] = await to(
      corpApi.queryHomeModuleDetail({ corpId, corpModuleId }),
    )
    if (err || !res.data) {
      return
    }

    // 处理数据
    const detail = res.data.map((item: any) => {
      // 拼oss地址
      item.image = item.image ? concatenateImageUrl(item.image) : ''
      return item
    })

    setDetail(detail)
  }

  /*
   * 点击跳转
   */
  function handleNavigation(index: number) {
    const item = detail[index]
    if (
      !item ||
      !item.detail ||
      !item.detail.dataType ||
      !item.detail.dataValue
    ) {
      return
    }

    const { dataType, dataValue, sort } = item.detail

    // 否则跳到 筛选结果
    navigate(
      `${routesMap.MarktingSearch}?dataType=${dataType}&dataValue=${dataValue}&sort=${sort}`,
    )
  }

  const NavItem = () => {
    return detail.map((item: ModuleDetails, index: number) => {
      return (
        <div
          className={styles['nav-item']}
          onClick={() => handleNavigation(index)}
          key={corpModuleId + index}
        >
          <div className={styles['img-wrap']}>
            <Image
              fit="cover"
              className={
                item.image ? styles['preview-img'] : styles['nav-img-icon']
              }
              src={item.image || iconNav}
              lazy={true}
            ></Image>
          </div>

          <span className={styles['title'] + ' ep-2'}>
            {capitalizeFirstLetter(item.title)}
          </span>
        </div>
      )
    })
  }

  useEffect(() => {
    getModuleDetail()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props])

  return (
    <div className={styles['nav-wrap']}>
      {/* 标题 */}
      <div className={styles['nav-title']}>
        <img className={styles['nav-title-icon']} src={categoryImg} />

        <span className={styles['nav-title-value']}>{t('Category')}</span>
      </div>

      <div className={styles['bd']}>
        <NavItem />
      </div>
    </div>
  )
}

export default Nav1
